import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function AssetsVersionSaveService(token,data) {
    return axios.post(`${CURRENT_API_URL}/contentmanagement/assetsVersionSave`,data,{
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        console.log(res.data)
        notify.NotifySuccess("Asset version saved successfully.");
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while saving asset version. Please try again later.");
        return false;
    });
}

export default AssetsVersionSaveService;
